import { addToCartAnalytics } from "~/analytics/AddToCart/addToCartAnalytics";
import Store from "./Store";
import { incrementItemsInCart } from "./Store/actions/user/index";

export default class Cart {
  private static instance: Cart;

  public constructor() {
    if (Cart.instance) return Cart.instance;

    Cart.instance = this;
  }

  private cartCountElement =
    document.getElementById("cartItemCountSpan") ||
    document.createElement("span");

  private internalCount = Number(this.cartCountElement.textContent);

  private reactHeader = document.querySelector(
    '[data-hypernova-key="GlobalHeader"]',
  );

  public get count() {
    return this.internalCount;
  }

  public set count(quantity) {
    if (this.reactHeader) return;

    this.internalCount = Number(quantity);
    this.cartCountElement.textContent = String(quantity);
  }

  public async add(body: FormData) {
    body.set("dynamicadd", "1");

    if (this.reactHeader) {
      Store.dispatch(incrementItemsInCart(Number(body.get("qty"))));
    } else {
      this.count += Number(body.get("qty"));
    }

    const addToCartRequest = await fetch("/viewcart.cfm", {
      body,
      method: "POST",
      credentials: "include",
    });
    if (!this.reactHeader) {
      const responseBody = await addToCartRequest.text();
      const doc = new DOMParser().parseFromString(responseBody, "text/html");

      const countElement = doc.querySelector(".count");

      if (countElement) this.count = Number(countElement.textContent);
    }

    addToCartAnalytics(
      { source: "Cart" },
      {
        itemNumber: body.get("item_number")?.toString() ?? "",
        quantity: Number(body.get("qty")),
      },
    );

    return addToCartRequest;
  }
}
